import { useCallback, useMemo, useState } from 'react'
import { X } from 'lucide-react'
import { AttachmentGallery } from '@/components/attachments/AttachmentGallery'
import { createPoWorkspaceAttachmentAdapter } from '@/services/attachments/poWorkspaceAttachmentAdapter'
import { Toast } from '@/components/ui/Toast'
import { shouldCloseDialog, useEscapeClose } from '@/hooks/useEscapeClose'
import type { PurchaseOrder } from '@/services/procurement'

export function PoQuickAttachmentDialog({
  po,
  onClose,
}: {
  po: PurchaseOrder
  onClose: () => void
}) {
  const [toastMessage, setToastMessage] = useState<string | null>(null)
  const adapter = useMemo(() => createPoWorkspaceAttachmentAdapter(po.id), [po.id])
  const requestClose = useCallback(() => {
    if (shouldCloseDialog(false)) onClose()
  }, [onClose])

  useEscapeClose({ enabled: true, hasUnsavedChanges: false, onClose: requestClose })

  return (
    <>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
        onMouseDown={(event) => {
          if (event.currentTarget === event.target) requestClose()
        }}
      >
        <div className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-[var(--radius-md)] bg-white p-4 shadow-xl" role="dialog" aria-modal="true" aria-label={`Thêm tài liệu cho ${po.code}`}>
          <div className="mb-3 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-slate-900">Thêm tài liệu — {po.code}</h3>
            <button type="button" aria-label="Đóng" className="rounded p-1 text-slate-500 hover:bg-slate-100 hover:text-slate-800" onClick={requestClose}>
              <X className="h-4 w-4" />
            </button>
          </div>
          <AttachmentGallery
            entityType="purchase_order"
            entityId={po.id}
            adapter={adapter}
            onFilesChanged={() => setToastMessage('Đã tải tài liệu lên PO')}
          />
        </div>
      </div>
      <Toast message={toastMessage} onDismiss={() => setToastMessage(null)} />
    </>
  )
}
